// 授信功能 （英）
module.exports = {}